import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { Img } from '@/components/blocks/MaterialImage';
import {
	cardSX,
	ctaButtonSX,
	ctaLinkSX,
	ctaWrapperSX,
	DpFanQuickCardVariant,
	imageFrameSX,
	imageSX,
	infoSX,
	subtitleSX,
	titleSX,
	VARIANTS,
} from '@/components/blocks/DpFanQuickCard/styles';
import { Box, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { parseHTML } from '@/utils/parseHTML';
import { combineSX } from '@/utils/combineSX';

export type { DpFanQuickCardVariant };

export interface DpFanQuickCardProps {
	variant?: DpFanQuickCardVariant;
	href: string;
	src: string;
	title: string;
	cta: string;
	subtitle?: string;
	alt?: string;
	framesx?: SxProps;
	onClick?: () => void;
}

export const DpFanQuickCard: FC<DpFanQuickCardProps> = ({
	variant = 'medium',
	href,
	src,
	title,
	cta,
	subtitle,
	alt,
	framesx,
	onClick,
}) => {
	const t = VARIANTS[variant];

	return (
		<Box className="dp-fan-quick-card" sx={combineSX([cardSX(t), framesx])}>
			<Box className="dp-fan-quick-card-image-frame" sx={imageFrameSX(t)}>
				<Img src={src} alt={alt ?? title} draggable={false} sx={imageSX} />
			</Box>
			<Box className="dp-fan-quick-card-info" sx={infoSX(t)}>
				<Typography component="h3" sx={titleSX(t)}>
					{title}
				</Typography>
				{subtitle ? <Typography sx={subtitleSX(t)}>{parseHTML(subtitle)}</Typography> : null}
				<Box sx={ctaWrapperSX(t)}>
					{t.ctaMode === 'button' ? (
						<DpButton href={href} variant="primary" sx={ctaButtonSX} fullWidth onClick={onClick}>
							{cta}
						</DpButton>
					) : (
						<DpButton href={href} variant="text" sx={ctaLinkSX} onClick={onClick}>
							{cta}
						</DpButton>
					)}
				</Box>
			</Box>
		</Box>
	);
};
